import { FEATURE_FLAGS, useFeatureExperiment } from '@blocs.features-experiments';
import { getEnvironment } from '@minecraft.environment';
import { MediaTypeCodeEnum } from '@minecraft.graphql-operations';
import { gqlMediaTypeCodeEnum } from '@minecraft.graphql-types';

export const useUploadWidgetPreset = () => {
  const featureFlagVideoPreset = useFeatureExperiment(FEATURE_FLAGS.WEB_REDWOOD_VIDEO_PRESET);
  const environment = getEnvironment();
  const uploadPresetVideo = environment?.UPLOAD_PRESET_VIDEO;
  const uploadPresetAudio = environment?.UPLOAD_PRESET_AUDIO;
  const uploadPresetDefault = environment?.UPLOAD_PRESET_DEFAULT;
  const uploadPresetAuthenticated = environment?.UPLOAD_AUTHENTICATED_PRESET;

  return ({
    mediaType,
    authenticatedUpload = false,
  }: {
    mediaType: MediaTypeCodeEnum | gqlMediaTypeCodeEnum;
    authenticatedUpload: boolean;
  }) => {
    if (authenticatedUpload) {
      // the authenticated preset currently is only supported for document uploads
      // it sets the asset to require a signed URL with a token to access the asset
      // and makes it so that it cannot be viewed publicly on the CDN
      return uploadPresetAuthenticated;
    }

    switch (mediaType) {
      // Doesn't contain any transformations, just points to specific folder (environment wise) e.g. qa or stg
      case MediaTypeCodeEnum.Photo:
      case MediaTypeCodeEnum.Document:
        return uploadPresetDefault;
      // Points to specific folder (environment wise) e.g. qa or stg
      // And has an eager video transformations to .mp4
      case MediaTypeCodeEnum.Video:
        return featureFlagVideoPreset || uploadPresetVideo;
      // Points to specific folder (environment wise) e.g. qa or stg
      // And has an eager video transformations to .mp3
      case MediaTypeCodeEnum.Audio:
        return uploadPresetAudio;
      default:
        return 'ml_default';
    }
  };
};
